import { render, staticRenderFns } from "./kechengxq.vue?vue&type=template&id=113e1449&scoped=true"
import script from "./kechengxq.vue?vue&type=script&lang=js"
export * from "./kechengxq.vue?vue&type=script&lang=js"
import style0 from "./kechengxq.vue?vue&type=style&index=0&id=113e1449&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e1449",
  null
  
)

export default component.exports